export const CONTINUE_TOKEN_HEADER = 'x-elexent-continue-token';

export function isValidPhoneNumber(phoneNumber) {
  return /^\+(?:[0-9]?){6,14}[0-9]$/.test(phoneNumber);
}

export function isValidEmail(email) {
  return /^\S+@\S+\.\S+$/.test(email);
}
